export enum AbortControllerNames {
  EmailClientApplicant = 'emailClientApplicant',
  PolicyPreview = 'policyPreview'
};
